import React from 'react'
import { useStyle } from './style'

const NotVisibleScreen = () => {
    const classes = useStyle()
  return (
    <div className={classes.notVisible}>
          <p>This screen is not visible on smaller devices</p>
    </div>
  )
}

export default NotVisibleScreen